import React, { useState, useEffect } from 'react';
import { BackHandler, ScrollView, StyleSheet, View, SafeAreaView, Platform } from 'react-native';

// import Constants from 'expo-constants';
import * as ImagePicker from 'expo-image-picker';
import Avatar from '../Avatar';
import Button, { BUTTON_TYPES } from '../Button';
import Camera from '../Camera';
import InputForm from '../InputForm';
import PickerSelect from '../PickerSelect';
import SwitchWithLabel from '../SwitchWithLabel';
import TitleForm from '../TitleForm';
import MessageAlert from '../../components/MessageAlert';
import { useSelector, useDispatch } from 'react-redux';
import { CommonProperties, CommonStyles } from '../../styles';
import { hasRegisteredStates, getStates } from '../../utils/country.utils';
import { validateEmail, ValidateZipCodeByCountryCode } from '../../utils/common.utils';
import { selectUserProfileImage } from '../../store/selectors/profile.selector';
import RowView from '../RowView';
import BottomButton from '../BottomButton';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useActionSheet } from '@expo/react-native-action-sheet';
import Icon from '../Icon';
import { pickImage } from '../../utils/image.utils';
import { deleteUserPicture, saveUserPicture } from '../../store/actions/profile';

const icon = (name) => <Icon name={name} size={24} />;

const UserForm = ({
  profile = {},
  countryList = [],
  approvalList = [],
  onSubmit,
  isUpdateAllowed = true,
}) => {
  const dispatch = useDispatch();
  const { tKey } = useComponentTKey('ProfileForm');
  const userImage = useSelector(selectUserProfileImage);
  const { t } = useTranslation(i18nNS.me);
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [suffix, setSuffix] = useState('');
  const [isValidError, setIsValidError] = useState(false);
  const [email, setEmail] = useState('');
  const [workPhone, setWorkPhone] = useState('');
  const [fax, setFax] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const [workAddress, setWorkAdress] = useState('');
  const [workAddress2, setWorkAddress2] = useState('');
  const [workCountry, setWorkCountry] = useState('');
  const [workState, setWorkState] = useState('');
  const [workCity, setWorkCity] = useState('');
  const [workZip, setWorkZip] = useState('');

  const [address, setAddress] = useState('');
  const [address2, setAddress2] = useState('');
  const [country, setCountry] = useState('');
  const [homeState, setHomeState] = useState('');
  const [city, setCity] = useState('');
  const [zip, setZip] = useState('');
  const [phone, setPhone] = useState('');
  const [homePhone, setHomePhone] = useState('');

  const [contactName, setContactName] = useState('');
  const [contactRelationship, setContactRelationship] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [contactNumber2, setContactNumber2] = useState('');

  const [securityAnswer1, setSecurityAnswer1] = useState('');
  const [securityAnswer2, setSecurityAnswer2] = useState('');
  const [securityAnswer3, setSecurityAnswer3] = useState('');

  const [securityListQuestions, setSecurityListQuestions] = useState([]);
  const [securityQuestion1, setSecurityQuestion1] = useState('');
  const [securityQuestion2, setSecurityQuestion2] = useState('');
  const [securityQuestion3, setSecurityQuestion3] = useState('');

  const [allowFullAccess, setAllowFullAccess] = useState(false);
  const [allowHomeInfo, setAllowHomeInfo] = useState(false);
  const [allowEmergencyInfo, setallowEmergencyInfo] = useState(false);

  const [showCamera, setShowCamera] = useState(false);
  const [image, setImage] = useState({ uri: userImage || '', base64: '' });
  const [approval, setApproval] = useState('');
  const [stateList, setStateList] = useState([]);
  const [stateWorkList, setStateWorkList] = useState([]);
  const [editTravellerName, setEditTravellerName] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const { showActionSheetWithOptions } = useActionSheet();
  const [isGranted, setIsGranted] = useState(true);

  const getPermissionAsync = async () => {
    // if (Constants.platform.ios) {
    if (Platform.OS !== 'web') {
      const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
      if (status !== 'granted') {
        setIsGranted(false);
      } else {
        setIsGranted(true);
      }
    }
    // }
  };

  const onSelectImage = (result) => {
    const newImage = {
      uri: result?.assets?.[0]?.uri,
      base64: result?.assets?.[0]?.base64.split(',')[1],
    };
    setImage(newImage);
    savePhoto(newImage);
  };

  useEffect(() => {
    if (hasRegisteredStates(country)) {
      (async () => {
        const res = await getStates(country);
        setStateList(res);
      })();
    }
    setHomeState('');
  }, [country]);

  useEffect(() => {
    if (hasRegisteredStates(workCountry)) {
      (async () => {
        const res = await getStates(workCountry);
        setStateWorkList(res);
      })();
    }
    setWorkState('');
  }, [workCountry]);

  useEffect(() => {
    getPermissionAsync();
    const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
      setShowCamera(false);
      return true;
    });

    return () => backHandler.remove();
  }, []);

  useEffect(() => {
    if (profile && Object.keys(profile).length > 0) {
      if (profile.ImageUrl) {
        setImage({
          base64: '',
          uri: profile.ImageUrl,
        });
      }
      setFirstName(profile.FirstName);
      setMiddleName(profile.MiddleName);
      setLastName(profile.LastName);
      setSuffix(profile.Title);
      setEmail(profile.Email);

      setHomePhone(profile.HomePhone);
      setPhone(profile.CellPhone);

      setWorkPhone(profile.WorkPhone);
      setFax(profile.Fax);
      setRecipientEmail(profile.ReceiptEmail);

      if (profile.WorkAddress) {
        setWorkAdress(profile.WorkAddress.Line1);
        setWorkAddress2(profile.WorkAddress.Line2);
        setWorkCountry(profile.WorkAddress.Country);
        setWorkState(profile.WorkAddress.State);
        setWorkCity(profile.WorkAddress.City);
        setWorkZip(profile.WorkAddress.Zip);
      }
      if (profile.HomeAddress) {
        setAddress(profile.HomeAddress.Line1);
        setAddress2(profile.HomeAddress.Line2);
        setCountry(profile.HomeAddress.Country);
        setHomeState(profile.HomeAddress.State);
        setCity(profile.HomeAddress.City);
        setZip(profile.HomeAddress.Zip);
      }

      setContactName(profile.EmergencyContact);
      setContactNumber(profile.EmergencyContactPhone);
      setContactNumber2(profile.EmergencyContactPhone2);
      setContactRelationship(profile.EmergencyContactRelation);

      setAllowFullAccess(profile.AllowFullAccessCompanyAdmin);
      setAllowHomeInfo(profile.AllowHomeInfoCompanyAdmin);
      setallowEmergencyInfo(profile.AllowEmergencyInfoCompanyAdmin);
      setApproval(profile.ApproverKey);
      setEditTravellerName(profile.EditTravellerName);

      if (profile.SecurityQuestionLst) {
        setSecurityListQuestions(
          profile.SecurityQuestionLst.map((item) => ({
            label: t(tKey('SecurityQuestion' + item.Id)),
            value: item.Id,
          }))
        );

        setSecurityQuestion1(profile.SecurityQuestionID.Id);
        setSecurityQuestion2(profile.SecurityQuestionID2.Id);
        setSecurityQuestion3(profile.SecurityQuestionID3.Id);
      }
    }
  }, [profile]);

  const isValid = () => {
    const _errorMessages = {};

    if (!lastName) {
      _errorMessages.lastName = t('common:Error.requiredLastName');
    }
    if (!firstName) {
      _errorMessages.firstName = t('common:Error.requiredFirstName');
    }
    if (!profile.UserAccountType === 'UserEmail') {
      if (!email) {
        _errorMessages.email = t('common:Error.requiredEmail');
      } else {
        if (!validateEmail(email)) {
          _errorMessages.email = t('common:Error.invalidEmail');
        }
      }
    }

    if (!workPhone) {
      _errorMessages.workPhone = t('common:Error.requiredWorkPhone');
    }

    if (!zip) {
      _errorMessages.zip = t('common:Error.requiredZipCode');
    }

    if (!country) {
      _errorMessages.country = t('common:Error.requiredCountry');
    }

    if (!workZip) {
      _errorMessages.workZip = t('common:Error.requiredZipCode');
    }

    if (!workCountry) {
      _errorMessages.workCountry = t('common:Error.requiredCountry');
    }

    if (zip && country && !ValidateZipCodeByCountryCode(zip, country)) {
      _errorMessages.zip = t('common:Error.invalidZipCode');
    }

    if (workZip && workCountry && !ValidateZipCodeByCountryCode(workZip, workCountry)) {
      _errorMessages.workZip = t('common:Error.invalidZipCode');
    }

    setErrorMessages(_errorMessages);

    return Object.keys(_errorMessages).length === 0;
  };

  const onPressSubmit = () => {
    setLoading(true);
    if (!isValid()) {
      setLoading(false);
      setIsValidError(true);
      setTimeout(() => {
        setIsValidError(false);
      }, 5000);
      return;
    }

    onSubmit({
      ...profile,
      ImageBytes: image.base64,
      //ImageBytes: Platform.OS !== 'web' ? image.base64 : image.base64.split(',')[1],
      Email: email,
      WorkPhone: workPhone,
      HomePhone: homePhone,
      Fax: fax,
      ReceiptEmail: recipientEmail,
      EmergencyContact: contactName,
      EmergencyContactRelation: contactRelationship,
      EmergencyContactPhone: contactNumber,
      EmergencyContactPhone2: contactNumber2,
      FirstName: firstName,
      LastName: lastName,
      MiddleName: middleName,
      CellPhone: phone,
      Title: suffix,
      WorkAddress: {
        ...profile.WorkAddress,
        Line1: workAddress,
        Line2: workAddress2,
        City: workCity,
        State: workCity,
        Country: workCountry,
        Zip: workZip.trim(),
      },
      HomeAddress: {
        ...profile.HomeAddress,
        Line1: address,
        Line2: address2,
        City: city,
        State: homeState,
        Country: country,
        Zip: zip.trim(),
      },
      SecurityQuestionID: {
        Id: securityQuestion1,
        Question: securityQuestion1
          ? securityListQuestions.find((s) => s.value === securityQuestion1).label
          : '',
      },
      SecurityQuestionID2: {
        Id: securityQuestion2,
        Question: securityQuestion2
          ? securityListQuestions.find((s) => s.value === securityQuestion2).label
          : '',
      },
      SecurityQuestionID3: {
        Id: securityQuestion3,
        Question: securityQuestion3
          ? securityListQuestions.find((s) => s.value === securityQuestion3).label
          : '',
      },
      SecurityAnswer: securityAnswer1,
      SecurityAnswer2: securityAnswer2,
      SecurityAnswer3: securityAnswer3,
      AllowFullAccessCompanyAdmin: allowFullAccess,
      AllowHomeInfoCompanyAdmin: allowHomeInfo,
      AllowEmergencyInfoCompanyAdmin: allowEmergencyInfo,
      ApproverKey: approval,
    });
  };

  const updatePhoto = () => {
    showActionSheetWithOptions(
      {
        options: [t(tKey('TakePhoto')), t(tKey('ChoosePhoto')), t('common:Cancel')],
        icons: [icon('camera'), icon('image'), icon('minus')],
        cancelButtonIndex: 2,
      },
      (buttonIndex) => {
        switch (buttonIndex) {
          case 0:
            return setShowCamera(true);
          case 1:
            return pickImage(onSelectImage);
          default:
        }
      }
    );
  };

  const savePhoto = (newImage) => {
    const data = {
      Id: profile.Id,
      Login: profile.Login,
      UserProfileId: profile.UserProfileId,
      ImageBytes: newImage.base64,
    };
    (async () => {
      await dispatch(saveUserPicture(data));
    })();
  };

  const deletePhoto = () => {
    setImage({ uri: null, base64: '' });
    const data = { Id: profile.Id, Login: profile.Login, UserProfileId: profile.UserProfileId };
    (async () => {
      await dispatch(deleteUserPicture(data));
    })();
  };

  useEffect(() => {
    setImage({ uri: userImage ? userImage : '', base64: '' });
  }, [userImage]);

  return (
    <SafeAreaView style={CommonStyles.flex1}>
      <ScrollView style={styles.container}>
        <RowView>
          <Avatar style={CommonStyles.mr3} size={110} source={image.uri ? image : null} />
          <View style={CommonStyles.justifyCenter}>
            <Button type={BUTTON_TYPES.TEXT} onPress={updatePhoto} label={t(tKey('UpdatePhoto'))} />
            {image.uri !== '' && (
              <Button
                type={BUTTON_TYPES.TEXT}
                onPress={deletePhoto}
                label={t(tKey('RemovePhoto'))}
              />
            )}
          </View>
        </RowView>
        <View style={CommonStyles.mt3}>
          {isUpdateAllowed && (
            <SwitchWithLabel
              value={allowFullAccess}
              onChange={() => {
                setAllowFullAccess(!allowFullAccess);
              }}
              label={t(tKey('EditPermission'))}
            />
          )}
          <InputForm
            label={t(tKey('FirstName'))}
            editable={editTravellerName}
            required={true}
            extra={t(tKey('MirrorId'))}
            value={firstName}
            errorMessage={errorMessages.firstName}
            onChangeText={setFirstName}
          />
          <InputForm
            label={t(tKey('MiddleName'))}
            value={middleName}
            editable={isUpdateAllowed}
            extra={t(tKey('MirrorId'))}
            onChangeText={setMiddleName}
          />
          <InputForm
            label={t(tKey('LastName'))}
            value={lastName}
            editable={editTravellerName}
            required={true}
            errorMessage={errorMessages.lastName}
            extra={t(tKey('MirrorId'))}
            onChangeText={setLastName}
          />
          <InputForm
            label={t(tKey('Suffix'))}
            value={suffix}
            editable={isUpdateAllowed}
            onChangeText={setSuffix}
          />
          <InputForm
            label={t(tKey('Email'))}
            value={email}
            editable={isUpdateAllowed}
            required={true}
            errorMessage={errorMessages.email}
            keyboardType="email-address"
            onChangeText={setEmail}
          />
          <InputForm
            label={t(tKey('WorkPhone'))}
            value={workPhone}
            editable={isUpdateAllowed}
            required={true}
            keyboardType="phone-pad"
            errorMessage={errorMessages.workPhone}
            onChangeText={setWorkPhone}
          />
          <InputForm label="Fax" value={fax} editable={isUpdateAllowed} onChangeText={setFax} />
          <InputForm
            label={t(tKey('ReceiptEmail'))}
            keyboardType="email-address"
            extra={t(tKey('extraInfo'))}
            value={recipientEmail}
            editable={isUpdateAllowed}
            onChangeText={setRecipientEmail}
          />
          <InputForm
            label={t(tKey('WorkAddress'))}
            value={workAddress}
            editable={isUpdateAllowed}
            onChangeText={setWorkAdress}
          />
          <InputForm
            label={t(tKey('Address2'))}
            value={workAddress2}
            editable={isUpdateAllowed}
            onChangeText={setWorkAddress2}
          />
          <PickerSelect
            label={t(tKey('Country'))}
            onValueChange={(value) => {
              setWorkCountry(value);
            }}
            items={countryList}
            value={workCountry}
            required={true}
            errorMessage={errorMessages.workCountry}
            placeholder={{ label: t(tKey('SelectCountry')) }}
            disabled={!isUpdateAllowed}
          />
          {hasRegisteredStates(workCountry) ? (
            <PickerSelect
              label={t(tKey('State'))}
              onValueChange={(value) => {
                setWorkState(value);
              }}
              items={stateWorkList}
              value={workState}
              disabled={!isUpdateAllowed}
              placeholder={{ label: t(tKey('SelectState')) }}
            />
          ) : (
            <InputForm
              label={t(tKey('State'))}
              value={workState}
              editable={isUpdateAllowed}
              onChangeText={setWorkState}
            />
          )}
          <InputForm
            label={t(tKey('City'))}
            value={workCity}
            editable={isUpdateAllowed}
            onChangeText={setWorkCity}
          />
          <InputForm
            label={t(tKey('Zip'))}
            value={workZip}
            editable={isUpdateAllowed}
            required={true}
            onChangeText={setWorkZip}
            maxLength={10}
            errorMessage={errorMessages.workZip}
          />
          <TitleForm title={t(tKey('PersonalInformation'))} />
          {isUpdateAllowed && (
            <SwitchWithLabel
              value={allowHomeInfo}
              onChange={() => {
                setAllowHomeInfo(!allowHomeInfo);
              }}
              label={t(tKey('EditAdressPermission'))}
            />
          )}
          <InputForm
            label={t(tKey('Address'))}
            value={address}
            editable={isUpdateAllowed}
            onChangeText={setAddress}
          />
          <InputForm
            label={t(tKey('Address2'))}
            value={address2}
            editable={isUpdateAllowed}
            onChangeText={setAddress2}
          />
          <PickerSelect
            label={t(tKey('Country'))}
            onValueChange={(value) => {
              setCountry(value);
            }}
            items={countryList}
            value={country}
            required={true}
            errorMessage={errorMessages.country}
            placeholder={{ label: t(tKey('SelectCountry')) }}
            disabled={!isUpdateAllowed}
          />
          {hasRegisteredStates(country) ? (
            <PickerSelect
              label={t(tKey('State'))}
              onValueChange={(value) => {
                setHomeState(value);
              }}
              items={stateList}
              value={homeState}
              disabled={!isUpdateAllowed}
              placeholder={{ label: t(tKey('SelectState')) }}
            />
          ) : (
            <InputForm
              label={t(tKey('State'))}
              value={homeState}
              editable={isUpdateAllowed}
              onChangeText={setHomeState}
            />
          )}
          <InputForm
            label={t(tKey('City'))}
            value={city}
            editable={isUpdateAllowed}
            onChangeText={setCity}
          />
          <InputForm
            label={t(tKey('Zip'))}
            value={zip}
            editable={isUpdateAllowed}
            maxLength={10}
            required={true}
            errorMessage={errorMessages.zip}
            onChangeText={setZip}
          />
          <InputForm
            label={t(tKey('CellPhone'))}
            value={phone}
            editable={isUpdateAllowed}
            keyboardType="phone-pad"
            onChangeText={setPhone}
          />
          <InputForm
            label={t(tKey('HomePhone'))}
            value={homePhone}
            editable={isUpdateAllowed}
            keyboardType="phone-pad"
            onChangeText={setHomePhone}
          />
          <TitleForm title={t(tKey('EmergencyContact'))} />
          {isUpdateAllowed && (
            <SwitchWithLabel
              value={allowEmergencyInfo}
              onChange={() => {
                setallowEmergencyInfo(!allowEmergencyInfo);
              }}
              label={t(tKey('EditContactPermission'))}
            />
          )}
          <InputForm
            label={t(tKey('Name'))}
            value={contactName}
            editable={isUpdateAllowed}
            onChangeText={setContactName}
          />
          <InputForm
            label={t(tKey('Relationship'))}
            value={contactRelationship}
            editable={isUpdateAllowed}
            onChangeText={setContactRelationship}
          />
          <InputForm
            label={t(tKey('Phone1'))}
            value={contactNumber}
            editable={isUpdateAllowed}
            keyboardType="phone-pad"
            onChangeText={setContactNumber}
          />
          <InputForm
            label={t(tKey('Phone2'))}
            value={contactNumber2}
            editable={isUpdateAllowed}
            keyboardType="phone-pad"
            onChangeText={setContactNumber2}
          />
          <TitleForm title={t(tKey('SecurityQuestions'))} />
          {securityListQuestions && (
            <PickerSelect
              label={t(tKey('SecurityQuestion1Label'))}
              onValueChange={setSecurityQuestion1}
              items={securityListQuestions.filter(
                (i) => i.value != securityQuestion2 && i.value != securityQuestion3
              )}
              value={securityQuestion1}
              placeholder={{ label: t(tKey('Security')) }}
              disabled={!isUpdateAllowed}
            />
          )}
          <InputForm
            label={t(tKey('Answer1'))}
            value={securityAnswer1}
            editable={isUpdateAllowed}
            secureTextEntry={true}
            placeholder="****"
            onChangeText={setSecurityAnswer1}
          />
          {securityListQuestions && (
            <PickerSelect
              label={t(tKey('SecurityQuestion2Label'))}
              onValueChange={setSecurityQuestion2}
              items={securityListQuestions.filter(
                (i) => i.value != securityQuestion1 && securityQuestion3
              )}
              value={securityQuestion2}
              placeholder={{ label: t(tKey('Security')) }}
              disabled={!isUpdateAllowed}
            />
          )}
          <InputForm
            label={t(tKey('Answer2'))}
            value={securityAnswer2}
            editable={isUpdateAllowed}
            placeholder="****"
            secureTextEntry={true}
            onChangeText={setSecurityAnswer2}
          />
          {securityListQuestions && (
            <PickerSelect
              label={t(tKey('SecurityQuestion3Label'))}
              onValueChange={setSecurityQuestion3}
              items={securityListQuestions.filter(
                (i) => i.value != securityQuestion1 && i.value != securityQuestion2
              )}
              value={securityQuestion3}
              placeholder={{ label: 'Select a Security Question' }}
              disabled={!isUpdateAllowed}
            />
          )}
          <InputForm
            label={t(tKey('Answer3'))}
            value={securityAnswer3}
            editable={isUpdateAllowed}
            placeholder="****"
            secureTextEntry={true}
            onChangeText={setSecurityAnswer3}
          />
          {/* commenting below code as moved Approval option to main Me screen */}
          {/* <TitleForm title={t(tKey('Approval'))} />
          <PickerSelect
            onValueChange={setApproval}
            items={approvalList}
            value={approval}
            placeholder={{ label: t(tKey('Approver')) }}
          /> */}
        </View>
      </ScrollView>
      {isUpdateAllowed && (
        <BottomButton onPress={onPressSubmit} label={t(tKey('UpdateProfile'))} loading={loading}>
          {isValidError && <MessageAlert message={t(tKey('Required'))} />}
        </BottomButton>
      )}
      {showCamera && (
        <Camera
          onClose={() => setShowCamera(false)}
          showRotate
          onGetImage={(data) => {
            setShowCamera(false);
            const newImage = {
              uri: data.uri,
              base64: data.base64 ? data.base64.split(',')[1] : '',
            };
            setImage(newImage);
            savePhoto(newImage);
          }}
        />
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...CommonProperties.py2,
    ...CommonProperties.px3,
  },
});

export default UserForm;
